<template>
	<section>
		<el-row :gutter="20">
			<el-col :span="12" :offset="6">
				<el-form ref="account" :model="account" label-width="200px" :rules="formRules">
					<el-form-item label="User Name">
						<el-input disabled v-model="account.userName"></el-input>
					</el-form-item>
					<el-form-item label="Email">
						<el-input disabled v-model="account.email"></el-input>
					</el-form-item>
					<el-form-item label="Phone" prop="phone">
						<el-input v-model="account.phone"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="changeUserInfo" :loading="loading">Save</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

	</section>
</template>


<script>
	import util from '../../common/js/util'
	import {changeUserInfo,getCurrentUser} from "../../api/securityService";

    export default {
		data() {
			return {
				account:{
					userName:"",
					phone:"",
					email:""
				},
				loading:false,
				formRules: {
					phone: [
						{ validator: this.checkPhone, trigger: 'blur' }
					]
				}

			}
		},
		methods: {
			checkPhone(rule, value, callback) {
				if (value.length===10) {
					callback();
				}else{
					return callback(new Error("Phone only allow 10 digits."));
				}
			},
            changeUserInfo(){
				this.$refs.account.validate((valid)=>{
					if(valid){
						let param = {
							mobile:this.account.phone
						};
						this.loading = true;
						changeUserInfo(param).then(res=>{
							this.loading = false;
							if(res.status===200){
								this.getCurrentUser();
								this.$message({
									message:res.message,
									type:"success"
								});
							}else{
								this.$message({
									message:res.message,
									type:"error"
								})
							}
						})
					}
				})
			},
            getCurrentUser(){
                getCurrentUser().then(res=>{
                    if(res.status===200){
                        this.account.userName = res.result.username;
                        this.account.email = res.result.email;
                        this.account.phone = res.result.mobile;
					}
				})
			}
		},
		mounted() {
			let user = sessionStorage.getItem("user");
			this.getCurrentUser();
		}
	}

</script>


// WEBPACK FOOTER //
// account.vue?73ed2d5c